import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { EMPTY } from 'rxjs';
import { catchError, finalize, takeUntil, tap } from 'rxjs/operators';

import { DestroySubscriptionsService } from '@libs/src/destroy-subscription/destroy-subscription.service';
import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { ToastService } from '@libs/src/toast/toast.service';

import { getServerError } from '@libs/src/error-handler/error-handler.helper';
import { UpdateGroupSuccess } from '@libs/src/groups/groups-store/groups.actions';
import { Group } from '@libs/src/models/group.model';
import { IAppState } from '@main-client/src/app/app.state';

@Component({
  providers: [DestroySubscriptionsService],
  selector: 'app-hub-config-roles-settings',
  templateUrl: './hub-config-roles-settings.component.html',
})
export class HubConfigRolesSettingsComponent implements OnInit {
  @Input() group: Group;
  isLoading = false;
  selectableForUserIntroductionControl = new FormControl(true);

  constructor(
    private readonly destroy$: DestroySubscriptionsService,
    private drawerRef: NzDrawerRef,
    private readonly groupsBackend: GroupsBackend,
    private readonly store: Store<IAppState>,
    private readonly toastService: ToastService,
  ) {}

  ngOnInit() {
    this.selectableForUserIntroductionControl.patchValue(
      this.group?.is_role_selectable_for_user_introduction_goals ?? true,
    );
  }

  closeDrawer() {
    this.drawerRef.close();
  }

  submitForm() {
    this.isLoading = true;
    this.groupsBackend
      .patchGroup(this.group, {
        is_role_selectable_for_user_introduction_goals:
          this.selectableForUserIntroductionControl.value,
      })
      .pipe(
        takeUntil(this.destroy$),
        tap((updatedGroup) => {
          this.store.dispatch(UpdateGroupSuccess({ group: updatedGroup }));
          this.drawerRef.close();
        }),
        catchError((error) => {
          this.toastService.showError(getServerError(error));
          return EMPTY;
        }),
        finalize(() => {
          this.isLoading = false;
        }),
      )
      .subscribe();
  }
}
